<div class="min-h-screen bg-white rounded-lg dark:bg-black mx-auto p-4">
  <p-breadcrumb
    [model]="displayBreadcrumbs()"
    styleClass="rounded-lg border border-gray-200 dark:border-gray-800"
  >
    <ng-template #separator>
      <i class="pi pi-chevron-right text-primary-400 text-sm mx-2"></i>
    </ng-template>
    <ng-template #item let-item>
      @if (item.routerLink) {
        <a
          [routerLink]="item.routerLink"
          class="flex items-center text-primary-600 hover:text-primary-800 dark:hover:text-primary-500 dark:text-primary-300 transition-colors duration-200"
        >
          @if (item.icon) {
            <i [class]="item.icon + ' mr-2'"></i>
          }
          <span>{{ item.label }}</span>
        </a>
      } @else {
        <span class="flex items-center text-primary-600 dark:text-primary-300">
          @if (item.icon) {
            <i [class]="item.icon + ' mr-2'"></i>
          }
          <span class="font-medium">{{ item.label }}</span>
        </span>
      }
    </ng-template>
  </p-breadcrumb>

  @if (enableSearch) {
    <div
      class="mb-6 mt-4 rounded-xl border border-gray-200 bg-white shadow-sm dark:border-gray-700 dark:bg-gray-800"
    >
      <div
        class="flex items-center justify-between border-b border-gray-200 px-4 py-3 dark:border-gray-700"
      >
        <div class="flex items-center gap-2">
          <i class="pi pi-search text-sm text-gray-500 dark:text-gray-400"></i>
          <span class="text-sm font-medium text-gray-800 dark:text-gray-100">Filtros</span>
          <span
            class="inline-flex items-center rounded-full bg-primary-100 px-2 py-0.5 text-[10px] font-semibold text-primary-700 dark:bg-primary-900/30 dark:text-primary-300"
          >
            {{ activeFiltersCount() }} activos
          </span>
        </div>
        <div class="flex items-center gap-2">
          @if (showClearFiltersButton && hasActiveFilters) {
            <button
              (click)="onClearFilters()"
              class="flex h-7 items-center gap-1.5 rounded-md px-2 text-xs text-gray-600 transition-colors hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-700"
              type="button"
            >
              <i class="pi pi-filter-slash text-[11px]"></i>
              <span>Limpiar</span>
            </button>
          }
        </div>
      </div>

      <div class="p-4">
        <div class="grid grid-cols-1 gap-3 sm:grid-cols-2">
          <div class="flex flex-col gap-1.5">
            <label
              class="text-xs font-medium text-gray-500 dark:text-gray-400"
              for="workflow-search"
            >
              Buscar
            </label>
            <div class="relative flex-1">
              <i class="pi pi-search absolute left-3 top-1/2 -translate-y-1/2 text-gray-400"></i>
              <input
                #searchInput
                (input)="search($any($event.target).value)"
                [placeholder]="searchPlaceholder"
                [value]="searchValue()"
                class="w-full pl-10!"
                id="workflow-search"
                pInputText
                type="text"
              />
            </div>
          </div>

          @if (showStatusFilter) {
            <div class="flex flex-col gap-1.5">
              <label
                class="text-xs font-medium text-gray-500 dark:text-gray-400"
                for="workflow-status"
              >
                Estado
              </label>
              <p-select
                (onChange)="onStatusFilterSelect($event.value)"
                [ngModel]="statusFilterValue"
                [options]="statusFilterOptions"
                class="w-full"
                id="workflow-status"
                optionLabel="label"
                optionValue="value"
                placeholder="Filtrar por estado"
              />
            </div>
          }
        </div>
      </div>
    </div>
  }
  @if (isLoading()) {
    <div class="flex justify-center items-center h-screen mt-8">
      <p-progressSpinner></p-progressSpinner>
    </div>
  }
  @if (!isLoading()) {
    <div>
      @if (filteredItems().length === 0 && !isLoading()) {
        <div class="flex flex-col items-center justify-center min-h-[500px] p-8">
          <div class="text-center max-w-md mx-auto">
            <!-- Icon -->
            <div class="mb-6">
              <div class="relative">
                <div
                  class="w-40 h-40 mx-auto mb-4 bg-gray-100 dark:bg-gray-700 rounded-full flex items-center justify-center"
                >
                  <i class="pi pi-file text-6xl text-blue-500 animate-pulse"></i>
                </div>
                <!-- Elementos decorativos opcionales -->
                <div
                  class="absolute -top-2 -right-2 w-6 h-6 bg-pink-300 dark:bg-pink-900 rounded-full animate-pulse"
                ></div>
                <div
                  class="absolute -bottom-1 -left-3 w-4 h-4 bg-purple-300 dark:bg-purple-900 rounded-full delay-700 animate-pulse"
                ></div>
              </div>
            </div>
            <!-- Title -->
            <h3 class="text-xl font-semibold text-gray-900 dark:text-white mb-3">
              {{ emptyStateTitle }}
            </h3>
            <!-- Description -->
            <p class="text-gray-600 dark:text-gray-400 mb-6 leading-relaxed">
              {{ emptyStateDescription }}
            </p>
            <!-- Action Button (optional) -->
            @if (showEmptyStateAction) {
              <div class="my-6">
                <p-button
                  (onClick)="onEmptyStateAction()"
                  [icon]="emptyStateActionIcon"
                  [label]="emptyStateActionLabel"
                  severity="secondary"
                />
              </div>
            }
            <!-- Additional info -->
            <div class="flex items-center justify-center space-x-2 text-sm text-gray-500">
              <i class="pi pi-info-circle"></i>
              <span>{{ emptyStateSubtext || 'No hay información disponible' }}</span>
            </div>
          </div>
        </div>
      } @else {
        <div class="min-h-[400px] grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-6 p-4">
          @if (filteredItems().length === 0) {
            <div class="col-span-full text-center py-8">
              <p class="text-gray-500">{{ noResultsMessage }}</p>
            </div>
          } @else {
            @for (item of filteredItems(); track item.id) {
              <div class="rounded-2xl">
                <article
                  [ngClass]="getCardBorderClass(item)"
                  class="relative block w-full text-left min-h-[220px] bg-white dark:bg-gray-900 rounded-2xl border border-gray-200 dark:border-gray-700 shadow-sm transition-shadow duration-200 hover:shadow-md p-6"
                >
                  <div class="relative z-10">
                    <div class="flex items-start justify-between gap-4">
                      <h3
                        [pTooltip]="getTitleTooltip(item)"
                        class="text-xl font-semibold text-gray-900 dark:text-white truncate"
                        tooltipPosition="top"
                      >
                        {{ getItemValue(item, cardConfig.titleKey) }}
                      </h3>

                      @if (cardConfig.clickable) {
                        <p-menu
                          #cardMenu
                          (onShow)="bindCardMenuHover(cardMenu)"
                          [appendTo]="'body'"
                          [model]="activeMenuItems()"
                          [popup]="true"
                        ></p-menu>
                        <p-button
                          (mouseenter)="openCardMenu($event, cardMenu, item)"
                          (mouseleave)="scheduleCardMenuHide(cardMenu, $event)"
                          class="inline-flex h-8 w-8 items-center justify-center rounded-md text-gray-700 transition-colors hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-800"
                          severity="secondary"
                          type="button"
                          variant="text"
                        >
                          <i class="pi pi-ellipsis-v text-lg"></i>
                        </p-button>
                      }
                    </div>

                    <div class="mt-8 space-y-4">
                      <div class="flex items-center justify-between">
                        <div
                          class="flex items-center gap-2 text-sm text-gray-500 dark:text-gray-400"
                        >
                          <span class="font-semibold">#</span>
                          <span>ID: {{ getFieldDisplayValue(item, 'id') }}</span>
                        </div>
                        <span
                          [ngClass]="getStatusBadgeClass(item)"
                          class="inline-flex items-center gap-2 rounded-full border px-2 py-1 text-xs font-semibold"
                        >
                          <span
                            [ngClass]="getStatusDotClass(item)"
                            class="h-1.5 w-1.5 rounded-full"
                          ></span>
                          {{ getStatusLabel(item) }}
                        </span>
                      </div>

                      <div class="flex items-start gap-2 text-sm text-gray-600 dark:text-gray-300">
                        <i class="pi pi-file mt-0.5 text-sm text-gray-500 dark:text-gray-400"></i>
                        <span class="truncate">{{ getDescriptionDisplayValue(item) }}</span>
                      </div>

                      <div
                        class="flex items-center justify-between border-t border-gray-200 dark:border-gray-700 pt-3"
                      >
                        <div
                          class="flex items-center gap-2 text-sm text-gray-600 dark:text-gray-300"
                        >
                          <i class="pi pi-clock text-sm text-gray-500 dark:text-gray-400"></i>
                          <span class="line-clamp-1 text-xs">
                            {{ getFieldDisplayValue(item, 'schedule') }}
                          </span>
                        </div>
                        <div
                          class="flex items-center gap-2 text-sm text-gray-600 dark:text-gray-300"
                        >
                          <i class="pi pi-chart-line text-sm text-gray-500 dark:text-gray-400"></i>
                          <span class="font-semibold text-xs text-gray-900 dark:text-white">
                            {{ getExecutionsDisplayValue(item) }}
                          </span>
                          <span class="text-xs">ejecuciones</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </article>
              </div>
            }
          }
        </div>
        @if (showPagination) {
          <div class="mt-8 flex justify-center">
            <p-paginator
              (onPageChange)="onPageChange($event)"
              [first]="paginatorFirst()"
              [rows]="limit()"
              [totalRecords]="totalRecords()"
            ></p-paginator>
          </div>
        }
      }
    </div>
  }
</div>
